module.exports = __webpack_public_path__ + "static/media/gryphonhouse-logo-taupe.91e3ed48.svg";